export default __webpack_public_path__ + "static/media/backup.a1a3a3d8.svg";